import { FunctionComponent, PropsWithChildren } from "react";
import { ITableProps } from "./interfaces/ITableProps";
import "./styles/table.css";

export const Table: FunctionComponent<PropsWithChildren<ITableProps>> = (props) => {
    const className = props.tableStyle === undefined ? "cui-table" : `cui-table ${props.tableStyle}`;

    return <table className={className}>{props.children}</table>;
};
